"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSET_ROLE = void 0;
exports.ASSET_ROLE = {
    DEFAULT: 'DEFAULT',
    STORE_AVATAR: 'STORE_AVATAR',
    STORE_MAIN_IMAGE: 'STORE_MAIN_IMAGE',
    STORE_BANNER_IMAGE: 'STORE_BANNER_IMAGE',
    PRODUCT_VARIANT_IMAGE: 'PRODUCT_VARIANT_IMAGE'
};
//# sourceMappingURL=assetRole.js.map